module.exports = __webpack_public_path__ + "img/celo.b0c3052a.png";